export default "__VITE_ASSET__ea3452b5__"